// removed by extract-text-webpack-plugin
module.exports = {"enter":"Collapse__enter___2osZ-","enterActive":"Collapse__enterActive___3uZ2A","appear":"Collapse__appear___2Fbmu","appearActive":"Collapse__appearActive___2FMOp","leave":"Collapse__leave___l6Dw5","leaveActive":"Collapse__leaveActive___2oVe_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Collapse/Collapse.scss
// module id = 2217
// module chunks = 0